import React, { PureComponent, Fragment } from 'react';
import {
  Container,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import ENV from '../../env';

const { IQBASE } = ENV;

class CostExplorer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      projectId: null,
      version: null,
      showLinks: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { projectId } = this.state;
    if (projectId > 1328034600000 && projectId < new Date().getTime()) {
      this.setState({
        showLinks: true,
      });
    } else {
      this.setState({
        showLinks: false,
      });
    }
  };

  getUrl = (projectId, version, type) => {
    if (version) {
      return `${IQBASE}/getCostOfProject/${projectId}?pv=${version}&type=${type}&out=csv`;
    }
    return `${IQBASE}/getCostOfProject/${projectId}?type=${type}&out=csv`;
  };

  renderLinks = ({ projectId, version }) => (
    <Fragment>
      <Row>
        <a
          rel="noreferrer noopener"
          target="_blank"
          href={this.getUrl(projectId, version, 'summary')}
        >
          Download Summary Report
        </a>
      </Row>
      <Row>
        <a
          rel="noreferrer noopener"
          target="_blank"
          href={this.getUrl(projectId, version, 'full')}
        >
          Download Itemized Report
        </a>
      </Row>
    </Fragment>
  );

  handleChange = async (event) => {
    const {
      target: { name, value },
    } = event;
    await this.setState({
      [name]: value,
      showLinks: false,
    });
  };

  render() {
    const { showLinks, projectId, version } = this.state;
    const newSearchForm = (
      <Form onSubmit={this.handleSubmit}>
        <FormGroup row>
          <Label sm={2} for="projectId">
            Project Id
          </Label>
          <Col sm={10}>
            <Input
              name="projectId"
              onChange={this.handleChange}
              id="projectId"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={2} for="imversionage">
            Version
          </Label>
          <Col sm={10}>
            <Input name="version" onChange={this.handleChange} id="version" />
          </Col>
        </FormGroup>
        <Button>Submit</Button>
      </Form>
    );

    const linkHeader = version
      ? `Reports for ${projectId} and ${version}`
      : `Reports for ${projectId}`;

    return (
      <Container>
        <div className="pt-2">
          <h2 className="py-3">Cost Explorer</h2>
          <Row>
            <Col md={8}>{newSearchForm}</Col>
          </Row>
          {showLinks && (
            <Row>
              <Col>
                <h2>{projectId && linkHeader}</h2>
              </Col>
              <Col>{this.renderLinks({ projectId, version })}</Col>
            </Row>
          )}
        </div>
      </Container>
    );
  }
}
export default CostExplorer;



// WEBPACK FOOTER //
// ./src/containers/CostExplorer/index.js